/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import noop from '../noop';
var Deprecations = /** @class */ (function () {
    function Deprecations() {
        this.deprecations = [];
    }
    Deprecations.get = function () {
        if (!Deprecations.instance) {
            Deprecations.instance = new Deprecations();
        }
        return Deprecations.instance;
    };
    Deprecations.deprecate = function (_a) {
        var name = _a.name, message = _a.message, version = _a.version;
        console.warn("DEPRECATED: ".concat(name, " is deprecated and will be removed in version ").concat(version, ", ").concat(message));
        Deprecations.get().deprecations.push({ name: name, message: message, version: version });
    };
    Deprecations.getDeprecations = function () {
        return Deprecations.get().deprecations;
    };
    Deprecations.clearDeprecations = function () {
        Deprecations.get().deprecations.length = 0;
    };
    Deprecations.instance = null;
    return Deprecations;
}());
var deprecate = function (_a) {
    var name = _a.name, message = _a.message, version = _a.version;
    return noop;
};
var useDeprecation = function (_a) {
    var name = _a.name, message = _a.message, version = _a.version;
    return noop;
};
var useComponentDeprecation = function (_a) {
    var name = _a.name, alternative = _a.alternative, version = _a.version;
    return noop;
};
var usePropDeprecation = function (_a) {
    var name = _a.name, alternative = _a.alternative, version = _a.version, value = _a.value;
    return noop;
};
// Since we have no module bundler it's the only way to detect dev env
var isReactDevelopment = function () { return '_self' in React.createElement('div'); };
if (isReactDevelopment()) {
    deprecate = Deprecations.deprecate;
    useDeprecation = function (_a) {
        var name = _a.name, message = _a.message, version = _a.version;
        useEffect(function () { return deprecate({ name: name, message: message, version: version }); }, []);
    };
    useComponentDeprecation = function (_a) {
        var name = _a.name, version = _a.version, alternative = _a.alternative;
        return useDeprecation({
            name: name,
            version: version,
            message: alternative
                ? "Please use ".concat(alternative, " component instead.")
                : "Please remove it carefully."
        });
    };
    usePropDeprecation = function (_a) {
        var name = _a.name, value = _a.value, version = _a.version, alternative = _a.alternative;
        if (value) {
            useDeprecation({
                name: name,
                version: version,
                message: alternative
                    ? "Please use ".concat(alternative, " prop instead.")
                    : "Please remove it carefully."
            });
        }
    };
}
export { useDeprecation, useComponentDeprecation, usePropDeprecation, deprecate, Deprecations, };
